import {EventEmitter} from 'events';

EventEmitter.prototype._maxListeners = 0;

export default EventEmitter;
